var $a6ca37a0a86010d1$exports = {};
$a6ca37a0a86010d1$exports = {
    "collectionLabel": `\u{3A0}\u{3C1}\u{3BF}\u{3C4}\u{3AC}\u{3C3}\u{3B5}\u{3B9}\u{3C2}`
};


export {$a6ca37a0a86010d1$exports as default};
//# sourceMappingURL=el-GR.mjs.map
